import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center" style={{ background: '#0A0A08' }}>
          <div className="text-center max-w-md p-8" style={{ border: '1px solid #27272A', borderRadius: '12px', background: '#111110' }}>
            <h2 className="text-xl font-semibold mb-2" style={{ color: '#F5F2E8' }}>Something went wrong</h2>
            <p className="text-sm mb-6" style={{ color: '#888880' }}>
              An unexpected error occurred. Please refresh the page to continue.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 text-sm rounded-md font-medium"
              style={{ background: '#FF5C1A', color: '#fff' }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
